<template>
  <div class="neilian">
    <iframe :src="url" style="height: 800px;width:1200px;margin:0 auto;" frameborder="0"></iframe>
  </div>
</template>

<script>
export default {
  name: "relatedProducts",
  data() {
    return {
      url: 'http://groupapp.risun.com:9003/ZBZHReport/ReportServer?reportlet=RISUN%2F%5B62a5%5D%5B8868%5D%5B5c55%5D%5B793a%5D%2F%5B8425%5D%5B9500%5D%2F%5B5316%5D%5B5de5%5D%5B5173%5D%5B8054%5D%5B4ef7%5D%5B683c%5D%5B66f4%5D%5B65b0%5D.cpt\n'
    }
  }
}
</script>

<style scoped>
.neilian {
  height: 800px;
  width: 1200px;
  margin: 30px auto;
  text-align: center;
}
</style>
